/** Write & send › when Lever was last checked, and "Check for replies now" (moved out of CampaignView, Oct 28 2026). */
export function ReplyCheckNow({ leverCheck, onCheck }: { leverCheck: { at: number; available: boolean } | null; onCheck: () => void }) {
  return (
    <span className="flex items-center gap-2 text-xs text-[#707070]">
      {leverCheck
        ? leverCheck.available
          ? `Lever checked ${new Date(leverCheck.at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`
          : 'Lever could not be read'
        : 'Lever not checked yet'}
      <button
        type="button"
        className="h-8 rounded-md border border-solid border-[#1A1A1A] bg-white px-3.5 text-xs font-semibold text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white"
        onClick={onCheck}
      >
        Check for replies now
      </button>
    </span>
  );
}
